import moment from "moment-timezone";

const toInstant = (value: string): number => moment(value.replace("[UTC]", "")).valueOf();

export const isGlobalDiscountStartDateRejected = (
	effectiveStartDate: string | undefined,
	lastSavedStartDate: string | undefined,
): boolean => {
	if (!effectiveStartDate) return false;

	const hasChanged =
		!lastSavedStartDate || toInstant(effectiveStartDate) !== toInstant(lastSavedStartDate);

	return hasChanged && moment(effectiveStartDate.replace("[UTC]", "")).isBefore(moment());
};
